import { render, staticRenderFns } from "./OrderStatis.vue?vue&type=template&id=4731e540&scoped=true&"
import script from "./OrderStatis.vue?vue&type=script&lang=js&"
export * from "./OrderStatis.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatis.vue?vue&type=style&index=0&id=4731e540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731e540",
  null
  
)

export default component.exports